import React, { Component } from "react";
import axios from "axios";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

export default class UpdateMockTestSeries extends Component {
  state = {
    id: "",
    test_series_name: "",
    payment_type: "free",
    negative_marking: "no",
    negative_marking_value: "",
    price: "",
    offer_price: "",
    status: "active",
    show_full_image_in_app: "false",
    duration_minutes: 10,
    syllabus: "",
    small_poster: null,
    large_poster: null,
    loading: false,
    notification: false,
    message: "",
    redirect: false,
  };

  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    this.setState({ id }, this.getTestSeriesDetails);
  }

  getTestSeriesDetails = async () => {
    try {
      if (init() === "success") {
        const resp = await axios.get(`${Constants.getUrls.getSingleTestSeries}${this.state.id}`);
        const data = resp?.data?.data || {};
        this.setState({
          test_series_name: data.test_series_name || "",
          payment_type: data.payment_type || "free",
          negative_marking: data.negative_marking || "no",
          negative_marking_value: data.negative_marking_value || "",
          price: data.price || "",
          offer_price: data.offer_price || "",
          status: data.status || "active",
          show_full_image_in_app: data.show_full_image_in_app === true ? "true" : "false",
          duration_minutes: data.duration_minutes || 10,
          syllabus: data.syllabus || "",
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Failed to load mock test series.",
      });
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("test_series_name", this.state.test_series_name);
    fd.append("payment_type", this.state.payment_type);
    fd.append("negative_marking", this.state.negative_marking);
    fd.append("negative_marking_value", this.state.negative_marking_value || 0);
    fd.append("price", this.state.price || 0);
    fd.append("offer_price", this.state.offer_price || 0);
    fd.append("status", this.state.status);
    fd.append("show_full_image_in_app", this.state.show_full_image_in_app);
    fd.append("duration_minutes", this.state.duration_minutes);
    fd.append("syllabus", this.state.syllabus);
    if (this.state.small_poster) {
      fd.append("small_poster", this.state.small_poster);
    }
    if (this.state.large_poster) {
      fd.append("large_poster", this.state.large_poster);
    }

    this.setState({ loading: true });

    try {
      const resp = await axios.put(`${Constants.putUrls.updateTestSeries}${this.state.id}`, fd);
      this.setState({
        loading: false,
        notification: true,
        message: resp.data.message,
      });
      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        loading: false,
        notification: true,
        message: err?.response?.data?.message || "Failed to update mock test series.",
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/testseries" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Edit Mock Test Series
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Test Series Name</InputLabel>
                    <TextField
                      name="test_series_name"
                      value={this.state.test_series_name}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Free or Paid</InputLabel>
                    <Select
                      name="payment_type"
                      value={this.state.payment_type}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="free">Free</MenuItem>
                      <MenuItem value="paid">Paid</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Negative Marking</InputLabel>
                    <Select
                      name="negative_marking"
                      value={this.state.negative_marking}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Duration (Minutes)</InputLabel>
                    <TextField
                      type="number"
                      name="duration_minutes"
                      value={this.state.duration_minutes}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      name="status"
                      value={this.state.status}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <InputLabel>App Card Layout</InputLabel>
                    <Select
                      name="show_full_image_in_app"
                      value={this.state.show_full_image_in_app}
                      onChange={this.handleInput}
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="false">Standard Card</MenuItem>
                      <MenuItem value="true">Full Image Card</MenuItem>
                    </Select>
                  </Grid>
                  {this.state.negative_marking === "yes" && (
                    <Grid item xs={12} md={4}>
                      <InputLabel>Deduct Marks Per Wrong Answer</InputLabel>
                      <TextField
                        type="number"
                        name="negative_marking_value"
                        value={this.state.negative_marking_value}
                        onChange={this.handleInput}
                        style={{ width: "100%" }}
                        required
                      />
                    </Grid>
                  )}
                  {this.state.payment_type === "paid" && (
                    <>
                      <Grid item xs={12} md={4}>
                        <InputLabel>Price</InputLabel>
                        <TextField
                          type="number"
                          name="price"
                          value={this.state.price}
                          onChange={this.handleInput}
                          style={{ width: "100%" }}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <InputLabel>Offer Price</InputLabel>
                        <TextField
                          type="number"
                          name="offer_price"
                          value={this.state.offer_price}
                          onChange={this.handleInput}
                          style={{ width: "100%" }}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} md={6}>
                    <InputLabel>Replace Small Image</InputLabel>
                    <TextField
                      type="file"
                      name="small_poster"
                      onChange={this.handleFile}
                      inputProps={{ accept: "image/*" }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel>Replace Large Image</InputLabel>
                    <TextField
                      type="file"
                      name="large_poster"
                      onChange={this.handleFile}
                      inputProps={{ accept: "image/*" }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel>Syllabus</InputLabel>
                    <TextField
                      multiline
                      minRows={4}
                      name="syllabus"
                      value={this.state.syllabus}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>

                <Grid align="left" mt={2}>
                  <MDButton variant="contained" size="small" color="info" type="submit">
                    {this.state.loading ? "Updating..." : "Update Mock Test Series"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color="success"
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
